import { useState } from "react";
import "./PastEvents.css";

export default function PastEvents({
    title = "EVENTOS PASADOS",
    events = [
        {
            title: "Da Vinci",
            logo: "/img/Logos/University_logos/Davinci.png",
            university: "Da Vinci",
            name: "UHUB x Da Vinci",
            date: "2024 - 2025 - 2026",
            image: "/img/Davinci.jpg",
            mask: "mask-02",
            description: "Durante 3 años consecutivos llevamos la experiencia UHUB a Da Vinci, consolidándonos como parte del ecosistema gamer y creativo de la institución. Con activaciones de simracing, CS2 y realidad virtual, conectamos a cientos de estudiantes con experiencias competitivas, tecnología y comunidad en cada edición.",
            social: "https://www.instagram.com/reel/DLdeGKIIXk1/",
        },
        {
            title: "UBA FCE",
            logo: "/img/Logos/University_logos/FCE.png",
            university: "FCE",
            name: "UHUB x UBA FCE",
            date: "2024 - 2025 - 2026",
            image: "/img/FCE.jpg",
            mask: "mask",
            description: "Durante 3 años consecutivos formamos parte de activaciones en la Facultad de Ciencias Económicas de la UBA, acercando gaming, tecnología y experiencias interactivas a miles de estudiantes. En nuestra última edición participamos dentro de EconTech, integrando esports, simracings, CS2 y realidad virtual en uno de los espacios de innovación y tecnología más importantes de la universidad.",
            social: "https://www.instagram.com/reel/DNTff0RREHv/",
        },
        {
            title: "UAI",
            logo: "/img/Logos/University_logos/UAI.png",
            university: "UAI",
            name: "UHUB x UAI",
            date: "2024 - 2025",
            image: "/img/UAI.jpg",
            mask: "mask",
            description: "Durante 2 años consecutivos llevamos la experiencia UHUB a la UAI, combinando gaming, tecnología y comunidad universitaria en activaciones de simracing, CS2 y realidad virtual. Además, participamos en un panel de speakers enfocado en educación, innovación y nuevas oportunidades dentro de la industria digital, compartiendo nuestra visión sobre el futuro del aprendizaje y el gaming.",
            social: "https://www.instagram.com/reel/DO11SncEafs/",
        },
        {
            title: "UNLP Informatica",
            logo: "/img/Logos/University_logos/UNLP.png",
            university: "UNLP",
            name: "UHUB x UNLP Informatica",
            date: "Septiembre 2024",
            image: "/img/FCE.jpg",
            mask: "mask",
            description: "Una activación pensada para estudiantes apasionados por la tecnología y el gaming. En la Facultad de Informática de la UNLP, combinamos experiencias competitivas de CS2 y realidad virtual en un entorno universitario lleno de innovación.",
            social: "https://www.instagram.com/reel/DPsMVwgkVBp/",
        },
        {
            title: "UTN Córdoba",
            logo: "/img/Logos/University_logos/SAE.png",
            university: "UTN Córdoba",
            name: "UHUB x UTN Córdoba",
            date: "Octubre 2025",
            image: "/img/UTN.jpg",
            mask: "mask-02",
            description: "Llevamos el universo UHUB a Córdoba con una activación enfocada en competencia, tecnología y comunidad. Los estudiantes disfrutaron de simracings, CS2 y experiencias VR en un entorno pensado para vivir el gaming de forma presencial.",
            social: "https://www.instagram.com/p/DJpcZKmRsct/",
        },
        {
            title: "EVA",
            logo: "/img/Logos/University_logos/EVA.png",
            university: "EVA",
            name: "UHUB x EVA",
            date: "Noviembre 2025",
            image: "/img/img_06.jpg",
            mask: "mask",
            description: "Una charla enfocada en Gaming Development e inteligencia artificial aplicada a la industria tecnológica y gamer. Compartimos tendencias, oportunidades y el impacto de la IA en el futuro del gaming y el desarrollo digital.",
            social: "https://www.instagram.com/p/DRDW3SIkVNh/",
        },
        {
            title: "UTN",
            logo: "/img/Logos/University_logos/SAE.png",
            university: "UTN",
            name: "UHUB x UTN",
            date: "Abril 2026",
            image: "/img/UTN.jpg",
            mask: "mask",
            description: "Llevamos la experiencia UHUB a la Facultad de Ciencias Agrarias y Forestales con una activación que unió tecnología, gaming y vida universitaria en un entorno diferente al tradicional circuito gamer. A través de experiencias de simracing, CS2 y realidad virtual, acercamos los esports y la innovación digital a nuevos espacios académicos y cientos de estudiantes.",
            social: "https://www.instagram.com/p/DJpcZKmRsct/",
        },
        {
            title: "Campus Day",
            logo: "/img/Logos/University_logos/SAE.png",
            university: "Campus Day",
            name: "UHUB x Campus Day",
            date: "Octubre 2024",
            image: "/img/UTN.jpg",
            mask: "mask-02",
            description: "El gaming tomó protagonismo en el Campus Day de Siglo XXI con una experiencia interactiva que reunió esports, tecnología y entretenimiento. Simracings, CS2 y VR fueron el centro de una activación creada para conectar estudiantes con nuevas experiencias digitales.",
            social: "//",
        },
        {
            title: "UNLZ Ingenieria",
            logo: "/img/Logos/University_logos/UNLZ.png",
            university: "UNLZ Ingenieria",
            name: "UHUB x UNLZ Ingenieria",
            date: "Noviembre 2024",
            image: "/img/UTN.jpg",
            mask: "mask-02",
            description: "Una jornada orientada a la comunidad de ingeniería donde mezclamos gaming competitivo y tecnología. Con estaciones de simracing y CS2, los estudiantes pudieron competir, conectar y descubrir el ecosistema universitario gamer.",
            social: "https://www.instagram.com/p/DJpMQM6R1FH/",
        },
        {
            title: "UNLP Cs Agrarias y Forestales",
            logo: "/img/Logos/University_logos/FranjaMorada.png",
            university: "UNLP Cs Agrarias y Forestales",
            name: "UHUB x UNLP Cs Agrarias y Forestales",
            date: "Septiembre 2025",
            image: "/img/img_06.jpg",
            mask: "mask-03",
            description: "Llevamos la experiencia UHUB a la Facultad de Ciencias Agrarias y Forestales con una activación que unió tecnología, gaming y vida universitaria en un entorno diferente al tradicional circuito gamer. A través de experiencias de simracing, CS2 y realidad virtual, acercamos los esports y la innovación digital a nuevos espacios académicos y cientos de estudiantes.",
            social: "https://www.instagram.com/p/DJpMQM6R1FH/",
        },
    ],

}) {
    const [selected, setSelected] = useState(events[0]);

    const toggle = (ev) => setSelected(ev);

    return (
        <section className="past" id="past-events">
            <div className="past-inner">
                <h2 className="past-title">{title}</h2>

                <ul className="past-tags" aria-label="Listado de eventos pasados">
                    {events.map((ev) => (
                        <li
                            className={`past-tag${selected?.title === ev.title ? " past-tag--active" : ""}`}
                            key={ev.title}
                            onClick={() => toggle(ev)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === "Enter" && toggle(ev)}
                        >
                            <span>{ev.title}</span>
                        </li>
                    ))}
                </ul>

                {selected && (
                    <div className="ev-stage">
                        <div className="ev-card" key={selected.title}>
                            {/* Left: image */}
                            <div className="ev-media">
                                {selected.image && (
                                    <img
                                        src={selected.image}
                                        alt={selected.name}
                                        className="ev-img"
                                        style={{
                                            WebkitMaskImage: `url(${process.env.PUBLIC_URL}/img/${selected.mask}.png)`,
                                            maskImage: `url(${process.env.PUBLIC_URL}/img/${selected.mask}.png)`,
                                            WebkitMaskSize: '100% 100%',
                                            maskSize: '100% 100%',
                                            WebkitMaskRepeat: 'no-repeat',
                                            maskRepeat: 'no-repeat',
                                        }}
                                    />
                                )}
                                <div className="ev-badge-wrap">
                                    <span className="ev-badge-uni">
                                        <img src={selected.logo} alt="" className="ev-badge-logo" />
                                        {selected.university}
                                    </span>
                                </div>
                            </div>

                            {/* Right: content */}
                            <div className="ev-body">
                                <div className="ev-header">
                                    <div>
                                        <h2 className="ev-name">{selected.name}</h2>
                                        <p className="ev-date">{selected.date}</p>
                                    </div>
                                    {selected.social && (
                                        <a href={selected.social} target="_blank" rel="noreferrer noopener" className="ev-social">
                                            <svg viewBox="0 0 24 24" fill="currentColor" aria-label="Instagram">
                                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.975.975 1.246 2.242 1.308 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.334 2.633-1.308 3.608-.975.975-2.242 1.246-3.608 1.308-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.334-3.608-1.308-.975-.975-1.246-2.242-1.308-3.608C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.516 2.497 5.783 2.225 7.15 2.163 8.416 2.105 8.796 2.163 12 2.163zm0-2.163C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
                                            </svg>
                                        </a>
                                    )}
                                </div>
                                <p className="ev-desc">{selected.description}</p>
                                {selected.description2 && <p className="ev-desc">{selected.description2}</p>}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
